<template>
  <div class="content">
    <div class="logo">
      <!-- <img style="width:100%;height:100%" :src="HERF+'/backstage/kycx.png'" alt="" /> -->
      <img
        style="width:100%;height:100%"
        src="../../assets/member/logo.png"
        alt=""
      />
    </div>
    <div class="font">
			欢迎来到卓越签到系统
		</div>

    <div class="input-box">
      <!-- <div class="input-box-left">用户名</div> -->
      <div class="input-box-right">
				 <!-- @change="oninputmobile" -->
        <input
          type="text"
          v-model="mobile"
          placeholder="请输入用户名"
          maxlength="11"
        />
      </div>
    </div>

    <div class="input-box">
      <!-- <div class="input-box-left">密码</div> -->
      <div class="input-box-right">
        <input type="password" placeholder="请输入密码" v-model="code" />
      </div>
      <!-- <div class="get-code" @click="get_code" v-show="count == 60">
        获取验证码
      </div>
      <div class="get-code count" v-show="count < 60">{{ count }}秒重试</div> -->
    </div>

    <div class="login-btn" @click="login">登录</div>

    <!-- <div class="login-mode" @click="wxsignin">
			<div class="flex flex_items">
				<img src="../../assets/member/wx.png">
				微信登录
			</div>
		</div> -->
  </div>
</template>

<script>
import { HERF } from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      mobile: "",
      code: "",
      count: 60,
      HERF: HERF,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    // this.getData()
  },
  methods: {
    getData(){
      this.api
        .score()
        .then((res) => {
          console.log(22);
        });
    },
    login() {
      if (!this.mobile) {
        return this.Toast("用户名不能为空");
      }
      if (!this.code) {
        return this.Toast("密码不能为空");
      }
      this.api
        .login({
          username: this.mobile,
          password: this.code,
        })
        .then((res) => {
          localStorage.setItem("user", JSON.stringify(res.data));
          localStorage.setItem("token", res.data.token);
          // this.getData()
          // role:'',//角色:会员member  工作人员officer 管控manager  管理员admin
          this.$router.push('/home')
        });
    },
    oninputmobile() {
      if (!/^1[34578]\d{9}$/.test(this.mobile)) {
        this.Toast("手机号码有误，请重填");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  // background-image: url(../../assets/login.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  //   background-position: center;
}

.logo {
  width: 100px;
  height: 100px;
  overflow: hidden;
  // border-radius: 50%;
  // background-color: #4fd9d5;
  margin: 30px auto 30px;
  margin-bottom: 16px;
}

.input-box {
  margin: 0 30px;
  margin-bottom: 20px;
  height: 50px;
  border: 1px solid #e6e6e6;
	background: #f0f0f0;
  border-radius: 25px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding:0 30px;

  .input-box-left {
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 20px;
      color: #cccccc;
    }
  }

  .input-box-right {
		// padding: 0 20px;
		// border-radius: 25px;
		// background: #f0f0f0;
    flex: 1;
    width: 100%;
    height: 100%;

    input {
      width: 100%;
      height: 100%;
      border: none;
      background-color: transparent;
      font-size: 18px;
    }
  }

  // .get-code {
  //   width: 2.12rem;
  //   height: 0.88rem;
  //   border-radius: 0.44rem;
  //   background-color: #4fd9d5;
  //   font-size: 0.3rem;
  //   color: #ffffff;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  // }
}

.login-btn {
  margin: 0 30px;
  height: 50px;
  background: #4fd9d5;
  box-shadow: 0px 3px 6px rgba(79, 217, 213, 0.3);
  border-radius: 25px;
  font-size: 18px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
}

.ps {
  margin: 0 0.24rem;
  font-size: 0.24rem;
  color: #cccccc;
  text-align: center;
  margin-top: 0.72rem;

  span {
    color: #4fd9d5;
  }
}

.division {
  margin: 0.3rem 0.24rem;
  height: 1px;
  background-color: #e6e6e6;
  position: relative;

  span {
    font-size: 0.36rem;
    font-weight: 400;
    color: #e6e6e6;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    padding: 0 0.4rem;
  }
}

.login-mode {
  display: flex;
  justify-content: center;
  margin-top: 0.6rem;
  background-color: #00d8cc;
  width: 6rem;
  height: 0.98rem;
  margin: 0 auto;
  border-radius: 0.16rem;
  color: #fff;
  font-size: 0.32rem;
  line-height: 0.98rem;

  img {
    width: 0.54rem;
    margin-right: 0.16rem;
  }

  p {
    font-size: 0.3rem;
    color: #999999;
    text-align: center;
  }
}

.count {
  background: #999999 !important;
}

.font {
  font-size: 18px;
  color: #1f3349;
  font-weight: 500;
  text-align: center;
  margin-bottom: 2.41rem;
}
</style>
